import { CONNECTIONS } from '@/config/constants';

const STORAGE_KEY = 'spate.ssoConnection';

const isValidConnection = (value) =>
    typeof value === 'string' && CONNECTIONS.includes(value);

export const getSsoConnection = () => {
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        return isValidConnection(value) ? value : null;
    } catch {
        return null;
    }
};

export const setSsoConnection = (connection) => {
    if (!isValidConnection(connection)) return;
    try {
        localStorage.setItem(STORAGE_KEY, connection);
    } catch {
        // ignore (Safari private mode, quota, etc.)
    }
};

export const clearSsoConnection = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
};

export const getSsoLoginOptions = () => {
    const connection = getSsoConnection();
    return connection ? { connection } : {};
};
